import {
	type ActiveScopeEntry,
	type PostOfficeContextValue,
	type RouteMatch,
	type RouteState,
	createMatchScopes,
} from '@atlassian/post-office-context';
import { createPlacementComponent } from '@post-office/placement-common/utils/create-placement-component';
import type { ErrorBoundariedProps } from '@post-office/placement-contexts/create-placement-component/types';
import { type ComponentType, memo } from 'react';

import { scopes } from './scopes';
import { PLACEMENT_ID } from '../__generated__/common';
import { withScreenSpaceFlagsIntlProvider } from '../__generated__/intl-provider';
import type { Placement as ScreenSpaceFlagsPlacementType } from '../contracts/Placement';
import { ScreenSpaceFlagsPlacement } from './placement';

export const matchedScopes = (input: {
	route: RouteState | RouteMatch;
	context: PostOfficeContextValue;
}): ActiveScopeEntry[] => createMatchScopes({ scopes })(input);

export const ScreenSpaceFlagsPlacementComponent: ComponentType<
	ErrorBoundariedProps<ScreenSpaceFlagsPlacementType>
> = withScreenSpaceFlagsIntlProvider(
	createPlacementComponent<ScreenSpaceFlagsPlacementType>(
		PLACEMENT_ID,
		memo((props) => {
			return <ScreenSpaceFlagsPlacement {...props} />;
		}),
		{
			choreographer: {
				isDefaultEnabled: true, // this is the default value, but leaving it as explicitly defined
			},
		},
	),
);

export default ScreenSpaceFlagsPlacementComponent;
